// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { TimeType } from './time-type';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TimeEntry extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  approved?: Date;
  approvedBy?: string;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  duration!: number;
  entryDate!: Date;
  notes?: string;
  timeTypeId!: number;
  userId!: number;
  timeType!: TimeType;
  user!: User;
}

